import styled from 'styled-components'

import breakpoints from '../../constants/ui/breakpoints'

export const TextPlusImageStyled = styled.div`
  display: flex;
  flex-direction: ${({ $isReverse }) => ($isReverse ? 'row-reverse' : 'row')};
  align-items: center;
  justify-content: space-between;
  gap: 2rem;

  @media (max-width: ${breakpoints.screenLG}) {
    margin-bottom: 2rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (max-width: ${breakpoints.screenMD}) {
    flex-direction: column-reverse;
    justify-content: center;
    gap: 0;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 45%;

    @media (max-width: ${breakpoints.screenMD}) {
      width: 100%;
      text-align: center;
    }
  }

  .img {
    display: flex;
    width: 45%;

    @media (max-width: ${breakpoints.screenMD}) {
      justify-content: center;
      width: 70%;
    }

    @media (max-width: ${breakpoints.screenSM}) {
      width: 100%;
    }
  }

  .video {
    border-radius: 1rem;
    width: 100%;
    max-width: 480px;
    margin: 2rem 0;
    overflow: hidden;
  }

  .player-wrapper {
    position: relative;
    padding-top: 56.25%;
  }

  .player {
    position: absolute;
    top: 0;
    left: 0;
  }
`
